// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function useTasksPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canReadTasks = authContext.isAuthorized(true, tenantId, IPermissions.TASKS_READ);
    var canReadDocumentPassword = authContext.isAuthorized(true, tenantId, IPermissions.DOCUMENT_PASSWORD_READ) &&
        authContext.isAuthorized(true, tenantId, IPermissions.DOCUMENT_DOWNLOAD);
    var canExportTasks = authContext.isAuthorized(true, tenantId, IPermissions.TASKS_EXPORT);
    var showTasksColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_TASKS_COLUMNS);
    var showTasksFilters = authContext.isAuthorized(true, tenantId, IPermissions.EE_TASKS_FILTERS);
    var showTasksBackButton = authContext.isAuthorized(true, tenantId, IPermissions.EE_TASKS_BACK_BUTTON);
    /**
     * Permissions
     */
    return {
        canReadTasks: canReadTasks,
        canReadDocumentPassword: canReadDocumentPassword,
        canExportTasks: canExportTasks,
        showTasksColumns: showTasksColumns,
        showTasksFilters: showTasksFilters,
        showTasksBackButton: showTasksBackButton,
    };
}
